



// import React from 'react';
// import { Link } from 'react-router-dom';
// import './Footer.css';

// const Footer = () => {
//   // Function to scroll to top
//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth', // Smooth scrolling
//     });
//   };

//   return (
//     <footer className="footer">
//       <div className="container">
//         <div className="footer-content">
//           <div className="footer-section">
//             <img src="/images/prologo.png" alt="ProCart India Logo" className="footer-logo" onClick={scrollToTop}/>
//             <p className="footer-description">
//               ProCart India is your one-stop shop for all hardware components. We provide high-quality products at competitive prices with excellent customer service.
//             </p>
//             <div className="connect-section">
//                 <div>
//                     <h3 className="footer-title" style={{left:'60px'}}>Keep in Touch</h3>
//                     <div className="social-icons">
//                         <a
//                             href="https://www.instagram.com/nextech_garage/"
//                             className="social-icon instagram"
//                             target="_blank"
//                             rel="noopener noreferrer"
//                         >
//                             <svg className="social-icon-svg" fill="currentColor" viewBox="0 0 24 24">
//                                 <path d="M12 2.04c-5.5 0-9.96 4.46-9.96 9.96 0 4.4 2.86 8.14 6.84 9.46.5.09.68-.22.68-.48 0-.24-.01-.87-.01-1.7-2.78.6-3.37-1.34-3.37-1.34-.45-1.15-1.1-1.46-1.1-1.46-.9-.62.07-.61.07-.61 1 .07 1.53 1.03 1.53 1.03.89 1.53 2.34 1.09 2.91.83.09-.65.35-1.09.63-1.34-2.22-.25-4.55-1.11-4.55-4.94 0-1.09.39-1.98 1.03-2.68-.1-.25-.45-1.27.1-2.65 0 0 .84-.27 2.75 1.02A9.58 9.58 0 0112 6.84c.85.004 1.71.114 2.52.33 1.91-1.29 2.75-1.02 2.75-1.02.55 1.38.2 2.4.1 2.65.64.7 1.03 1.59 1.03 2.68 0 3.84-2.34 4.68-4.57 4.93.36.31.68.92.68 1.85 0 1.34-.01 2.42-.01 2.75 0 .27.18.58.69.48A9.963 9.963 0 0022 12c0-5.5-4.46-9.96-9.96-9.96z" />
//                             </svg>
//                         </a>

//                         <a href="#" className="social-icon linkedin">
//                             <svg className="social-icon-svg" fill="currentColor" viewBox="0 0 24 24">
//                                 <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.761 0 5-2.239 5-5v-14c0-2.761-2.239-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.784-1.75-1.75s.784-1.75 1.75-1.75 1.75.784 1.75 1.75-.784 1.75-1.75 1.75zm13.5 12.268h-3v-5.604c0-1.337-.027-3.063-1.867-3.063-1.867 0-2.153 1.459-2.153 2.966v5.701h-3v-11h2.879v1.526h.041c.401-.761 1.381-1.562 2.841-1.562 3.037 0 3.6 2 3.6 4.604v6.432z" />
//                             </svg>
//                         </a>
//                         <a href="#" className="social-icon twitter">
//                             <svg className="social-icon-svg" fill="currentColor" viewBox="0 0 24 24">
//                                 <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-2.717 0-4.92 2.203-4.92 4.917 0 .385.045.762.127 1.124-4.09-.205-7.719-2.165-10.141-5.144-.424.722-.666 1.561-.666 2.457 0 1.694.859 3.188 2.164 4.065-.797-.025-1.548-.245-2.202-.611v.061c0 2.367 1.684 4.342 3.918 4.789-.41.111-.842.171-1.287.171-.314 0-.621-.03-.921-.086.623 1.947 2.431 3.365 4.576 3.403-1.674 1.313-3.779 2.096-6.07 2.096-.394 0-.787-.022-1.173-.066 2.179 1.398 4.768 2.212 7.548 2.212 9.054 0 14.002-7.496 14.002-14.002 0-.213-.005-.426-.014-.637.961-.695 1.797-1.562 2.457-2.549z" />
//                             </svg>
//                         </a>
//                     </div>

//                 </div>
//             </div>
//           </div>

//           <div className="footer-section">
//             <h3 className="footer-title">Company</h3>
//             <ul className="footer-links">
//               <li>
//                 <Link to="/" onClick={scrollToTop}>Home</Link>
//               </li>
//               <li><Link to="/about-us">About Us</Link></li> {/* Update this link to point to our new route */}
//               <li><Link to="/products">Products</Link></li>

//               <li><Link to="/faq">Contact & FAQ</Link></li>
//             </ul>
//           </div>

//           <div className="footer-section">
//             <h3 className="footer-title">Useful Links</h3>
//             <ul className="footer-links">
//               <li><Link to="/blog">Blog</Link></li>
//               <li><Link to="/newsroom">Newsroom</Link></li>
//               {/* <li><Link to="/contact">Contact Us</Link></li> */}
//               <li><Link to="https://www.spherenex.com/" target='_main'>Developers</Link></li>
//             </ul>
//           </div>


//           <div className="footer-section">
//             <h3 className="footer-title">Contact Info</h3>
//             <ul className="contact-info">
//               <li>
//                 <i className="fas fa-map-marker-alt"></i>
//                 <span>No.48/58, 1st floor, Chunchgatta Main Rd,<br/> 
//                   JP Nagar 7th Phase, Konanakunte, <br/>
//                   Bengaluru, Karnataka - 560062</span>
//               </li>
//               <li>
//                 <i className="fas fa-phone-alt"></i>
//                 <span>+91 9606271260</span>
//               </li>
//               <li>
//                 <i className="fas fa-envelope"></i>
//                 <span>info@procartindia.com</span>
//               </li>
//               <li>
//                 <i className="fas fa-clock"></i>
//                 <span>Mon - Sat: 9:00 AM - 8:00 PM</span>
//               </li>
//             </ul>
//           </div>
//         </div>

//         <div className="footer-bottom">
//           <div className="copyright">
//             © {new Date().getFullYear()} ProCart India. All Rights Reserved.
//           </div>
//           <div className="payment-methods">
//             <span>We Accept:</span>
//             <span style={{color:'#ef4444',fontWeight:'bold'}}>info@procartindia.com</span>
//             <i className="fab fa-cc-visa"></i>
//             <i className="fab fa-cc-mastercard"></i>
//             <i className="fab fa-cc-amex"></i>
//             <i className="fab fa-cc-paypal"></i>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;




import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  // Function to scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Smooth scrolling
    });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <img src="/images/Procart_Logo.jpg" alt="ProCart India Logo" className="footer-logo" onClick={scrollToTop} />
            <p className="footer-description">
              ProCart India is your one-stop shop for all hardware components. We provide high-quality products at competitive prices with excellent customer service.
            </p>
            
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Company</h3>
            <ul className="footer-links">
              <li>
                <Link to="/" onClick={scrollToTop}>Home</Link>
              </li>
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to="/products">Products</Link></li>
              <li><Link to="/faq">Contact & FAQ</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Useful Links</h3>
            <ul className="footer-links">
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/newsroom">Newsroom</Link></li>
              <li><Link to="/demo-projects">Electronics Lab Kits</Link></li>
              <li><a href="https://spherenex-internship-portal.vercel.app/" target="_blank" rel="noopener noreferrer">Student Login</a></li>
              <li><Link to="https://www.spherenex.com/" target='_main'>Developers</Link></li>
            </ul>
          </div>


          <div className="footer-section">
            <h3 className="footer-title">Contact Info</h3>
            <ul className="contact-info">
              <li>
                <i className="fas fa-map-marker-alt"></i>
                <span>No.48/58, 1st floor, Chunchgatta Main Rd,<br />
                  JP Nagar 7th Phase, Konanakunte, <br />
                  Bengaluru, Karnataka - 560062</span>
              </li>
              <li>
                <i className="fas fa-phone-alt"></i>
                <span>+91 9606271260</span>
              </li>
              <li>
                <i className="fas fa-envelope"></i>
                <span>info@procartindia.com</span>
              </li>
              <li>
                <i className="fas fa-clock"></i>
                <span>Mon - Sat: 9:00 AM - 8:00 PM</span>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Legal</h3>
            <ul className="footer-links">
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/shipping-policy">Shipping & Refund Policy</Link></li>
              <li><Link to="/terms-of-use">Terms of Use</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="footer-title">Keep in Touch</h3>
            <div className="social-icons">
              <a
                href="https://www.instagram.com/nextech_garage/"
                className="social-icon instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg className="social-icon-svg" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.04c-5.5 0-9.96 4.46-9.96 9.96 0 4.4 2.86 8.14 6.84 9.46.5.09.68-.22.68-.48 0-.24-.01-.87-.01-1.7-2.78.6-3.37-1.34-3.37-1.34-.45-1.15-1.1-1.46-1.1-1.46-.9-.62.07-.61.07-.61 1 .07 1.53 1.03 1.53 1.03.89 1.53 2.34 1.09 2.91.83.09-.65.35-1.09.63-1.34-2.22-.25-4.55-1.11-4.55-4.94 0-1.09.39-1.98 1.03-2.68-.1-.25-.45-1.27.1-2.65 0 0 .84-.27 2.75 1.02A9.58 9.58 0 0112 6.84c.85.004 1.71.114 2.52.33 1.91-1.29 2.75-1.02 2.75-1.02.55 1.38.2 2.4.1 2.65.64.7 1.03 1.59 1.03 2.68 0 3.84-2.34 4.68-4.57 4.93.36.31.68.92.68 1.85 0 1.34-.01 2.42-.01 2.75 0 .27.18.58.69.48A9.963 9.963 0 0022 12c0-5.5-4.46-9.96-9.96-9.96z" />
                </svg>
              </a>

             <a
                href="https://www.linkedin.com/company/spherenex/"
                className="social-icon linkedin"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg className="social-icon-svg" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.761 0 5-2.239 5-5v-14c0-2.761-2.239-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.784-1.75-1.75s.784-1.75 1.75-1.75 1.75.784 1.75 1.75-.784 1.75-1.75 1.75zm13.5 12.268h-3v-5.604c0-1.337-.027-3.063-1.867-3.063-1.867 0-2.153 1.459-2.153 2.966v5.701h-3v-11h2.879v1.526h.041c.401-.761 1.381-1.562 2.841-1.562 3.037 0 3.6 2 3.6 4.604v6.432z" />
                </svg>
              </a>
              <a href="#" className="social-icon twitter">
                <svg className="social-icon-svg" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-2.717 0-4.92 2.203-4.92 4.917 0 .385.045.762.127 1.124-4.09-.205-7.719-2.165-10.141-5.144-.424.722-.666 1.561-.666 2.457 0 1.694.859 3.188 2.164 4.065-.797-.025-1.548-.245-2.202-.611v.061c0 2.367 1.684 4.342 3.918 4.789-.41.111-.842.171-1.287.171-.314 0-.621-.03-.921-.086.623 1.947 2.431 3.365 4.576 3.403-1.674 1.313-3.779 2.096-6.07 2.096-.394 0-.787-.022-1.173-.066 2.179 1.398 4.768 2.212 7.548 2.212 9.054 0 14.002-7.496 14.002-14.002 0-.213-.005-.426-.014-.637.961-.695 1.797-1.562 2.457-2.549z" />
                </svg>
              </a>
            </div>

          </div>


        </div>

        <div className="footer-bottom">
          <div className="copyright">
            © {new Date().getFullYear()} ProCart India A unit of NexSpyder Technologies Pvt. Ltd.. All Rights Reserved.
          </div>
          <div className="payment-methods">
            <span>We Accept:</span>
            <span style={{ color: '#ef4444', fontWeight: 'bold' }}>info@procartindia.com</span>
            <i className="fab fa-cc-visa"></i>
            <i className="fab fa-cc-mastercard"></i>
            <i className="fab fa-cc-amex"></i>
            <i className="fab fa-cc-paypal"></i>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;